import { toggleMenu } from "../../_src/components/dropdown"
import { purify } from "../../_src/components/purify"
export function searchCredenciamentos() {


  function search(data) {
    const resultTeste = document.querySelectorAll('.results-accordions-container')
    var btn = document.getElementById(data.id)

    btn.classList.add("loading")

    document.querySelector(".loader-accreditation").classList.remove("hidden")

    resultTeste.forEach((result) => {
      result.innerHTML = ""
    })

    document.querySelectorAll(".question__answer button").forEach(function (el) {
        el.classList.add("disabled")
    })

    fetch(`/credenciamento/accordion-edital/index.html?categoria=${data.categoria}&status=${data.status}&tipoPessoa=${data.pessoa}`)
    .then((response) => {
        return response.text();
    }).then((response) => {
          resultTeste.forEach((result) => {
            result.innerHTML = purify(response)
          })
    })
    .catch((error) => {
        console.error(error);
    })
    .finally(() => {
        toggleMenu()

        document.querySelector(".loader-accreditation").classList.add("hidden")

        btn.classList.remove("loading")

        document.querySelectorAll(".question__answer button").forEach(function (el) {
            el.classList.remove("disabled")
        })

    });
  }



  const btn1 = document.querySelector('[data-contentid=credenciamento-andamento]')
  const btn2 = document.querySelector('[data-contentid=credenciamento-concluido]')


  btn1?.addEventListener('click', ()=>{
      const resultPosProccess = document.querySelectorAll('.results-accordions-container')
      resultPosProccess.forEach((container) => {
        container.innerHTML = ""
      })
      document.querySelectorAll("[data-action=select-year]").forEach(function (btn) {
        btn.classList.remove("active")
      })
    })

  btn2?.addEventListener('click', ()=>{
      const resultPosProccess = document.querySelectorAll('.results-accordions-container')
      resultPosProccess.forEach((container) => {
        container.innerHTML = ""
      })
      document.querySelectorAll("[data-action=select-year]").forEach(function (btn) {
        btn.classList.remove("active")
      })
  })




  document.querySelectorAll("[data-action=select-year]").forEach(function (btn) {
      const dropdown = document.querySelectorAll("main [data-action=open-dropdown]")
      const accordions = document.querySelectorAll("main [data-content=content-accordions]")

      dropdown?.forEach(function (e) {
        e.style.display = "none"
      })

      btn.addEventListener("click", function () {
        accordions?.forEach(function (e) {
          e.style.display = "flex"
        })

          if (this.classList.contains("active")) {
            return
          }
          search(this.dataset)


          document.querySelectorAll("[data-action=select-year]").forEach(function (btn) {
            btn.classList.remove("active")
            dropdown.forEach(function (e) {
                e.style.display = "none"
            })
          })
          dropdown.forEach(function (e) {
            e.style.display = "flex"
          })
          this.classList.add("active")
      })
  })

}

if (document.querySelector("[data-action=select-year]")) {
  searchCredenciamentos();
}
